import { User } from "../types/user";

export const getUser = (state: any): User => state.main.user;
